import { memo } from "react";
import * as AlertIcons from "./AlertIcons";
import * as NavIcons from "./NavIcons";
import * as DeviceStatusIcons from "./DeviceStatusIcons";

export { default as AnimatedSvg, anim, DELAY, FILL_BOX, resolveTrigger } from "./AnimatedSvg";

// Tüm ikonlar memo'lu: animasyon CSS'tedir (React render'ı tetiklemez); prop'ları
// aynı kalan ikon, ebeveyn yeniden render olsa da (ör. dashboard'a socket verisi
// geldikçe) yeniden çizilmez. Animasyon yalnız eleman yeniden MOUNT edilince
// baştan başlar — bu yüzden ikonlar render içinde satır içi bileşen olarak
// tanımlanmamalı (bkz. AlertsPage HeaderBell).
export const AlertBellIcon = memo(AlertIcons.AlertBellIcon);
export const CriticalDeviceIcon = memo(AlertIcons.CriticalDeviceIcon);
export const SignalLostIcon = memo(AlertIcons.SignalLostIcon);
export const IdleCupIcon = memo(AlertIcons.IdleCupIcon);
export const ServiceWrenchIcon = memo(AlertIcons.ServiceWrenchIcon);
export const PlaymakerTruckIcon = memo(AlertIcons.PlaymakerTruckIcon);
export const CriticalQuotaIcon = memo(AlertIcons.CriticalQuotaIcon);
export const NoOrderIcon = memo(AlertIcons.NoOrderIcon);
export const LowPerformanceIcon = memo(AlertIcons.LowPerformanceIcon);
export const BillReceiptIcon = memo(AlertIcons.BillReceiptIcon);
export const AllClearIcon = memo(AlertIcons.AllClearIcon);
export const DashboardGridIcon = memo(NavIcons.DashboardGridIcon);
export const TasksIcon = memo(NavIcons.TasksIcon);
export const GitBranchIcon = memo(NavIcons.GitBranchIcon);
export const DeviceScreenIcon = memo(NavIcons.DeviceScreenIcon);
export const BuildingIcon = memo(NavIcons.BuildingIcon);
export const CustomerIcon = memo(NavIcons.CustomerIcon);
export const StoreIcon = memo(NavIcons.StoreIcon);
export const UsersIcon = memo(NavIcons.UsersIcon);
export const SalesChartIcon = memo(NavIcons.SalesChartIcon);
export const InvoiceUploadIcon = memo(NavIcons.InvoiceUploadIcon);
export const HandshakeIcon = memo(NavIcons.HandshakeIcon);
export const WalletIcon = memo(NavIcons.WalletIcon);
export const SendIcon = memo(NavIcons.SendIcon);
export const ReportSearchIcon = memo(NavIcons.ReportSearchIcon);
export const FactoryIcon = memo(NavIcons.FactoryIcon);
export const PartsBoxIcon = memo(NavIcons.PartsBoxIcon);
export const MachineCupIcon = memo(NavIcons.MachineCupIcon);
export const MapPinDropIcon = memo(NavIcons.MapPinDropIcon);
export const CatalogGridIcon = memo(NavIcons.CatalogGridIcon);
export const DocumentsIcon = memo(NavIcons.DocumentsIcon);
export const ClipboardCheckIcon = memo(NavIcons.ClipboardCheckIcon);
export const HourglassIcon = memo(NavIcons.HourglassIcon);
export const CloudDataIcon = memo(NavIcons.CloudDataIcon);
export const ShieldCheckIcon = memo(NavIcons.ShieldCheckIcon);
export const ProductTagIcon = memo(NavIcons.ProductTagIcon);
export const TypeCursorIcon = memo(NavIcons.TypeCursorIcon);
export const CityIcon = memo(NavIcons.CityIcon);
export const MapPinIcon = memo(NavIcons.MapPinIcon);
export const ServiceToolIcon = memo(DeviceStatusIcons.ServiceToolIcon);
export const TestBeakerIcon = memo(DeviceStatusIcons.TestBeakerIcon);
export const ChipIcon = memo(DeviceStatusIcons.ChipIcon);
